const HREF_REGEX = /href\s*=\s*["']([^"']*)["']/i;

export const getTextPopup = (text?: string | null) =>
  text?.replace(/<a[^>]*>(.*?)<\/a>/i, (match, innerText) => {
    const href = match.match(HREF_REGEX)?.[1];
    return href ? `<a href="${href}">${innerText.split('?')[0]}</a>` : match;
  }) || '';

export const getCopyText = (text: string, textPopup: string) => {
  const href = textPopup.match(HREF_REGEX)?.[1] || text.match(HREF_REGEX)?.[1];
  return href ? text.replace(/https?:\/\/[^\s]+/g, href) : text;
};

const normalizeWhitespace = (text: string) =>
  text
    .replace(/^[ \t]+|[ \t]+$/gm, '') 
    .replace(/\n{3,}/g, '\n\n')
    .trim();

export const processInformText = (text?: string | null, cabmunId?: number | string) => {
  if (!text) return '';
  
  const processed = text.replaceAll('{{cabmun_id}}', String(cabmunId || ''));
  return normalizeWhitespace(processed);
};